import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  input,
  OnChanges,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { interval, Subscription, takeWhile } from 'rxjs';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent implements OnChanges {
  @Input({
    required: true,
  })
  config!: { percent: number; title: string };
  counter = 0;

  private progressSub?: Subscription;

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      isPlatformBrowser(this.platformId) &&
      changes['config'] &&
      changes['config'].currentValue.percent !== undefined
    ) {
      this.counter = 0;
      this.startProgress();
    }
  }

  startProgress() {
    this.progressSub?.unsubscribe(); // Clean up if already running
    this.progressSub = interval(2)
      .pipe(takeWhile(() => this.counter < this.config.percent))
      .subscribe(() => {
        this.counter += 5;
        this.cdr.detectChanges();
      });
  }
}
